/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOrderingProfileLocations} from '../api'

 export const useQueryGetOrderingProfileLocations = createReactQueryHook('getOrderingProfileLocations', getOrderingProfileLocations)
